<template>
  <div style="min-width: 1600px;flex-grow: 1;height: 100%;display: flex;flex-direction: column">
    <div v-if="!!upElementBlock" class="section" style="margin-top: 2px">
      <span class="title">{{ upElementBlock.title }}</span>
      <el-form label-width="90px" label-position="left" inline>
        <slot v-for="elementName in upElementBlock.elementNames" :name="elementName" />
      </el-form>
    </div>
    <div v-if="!!downElementBlock" class="section" style="flex-grow: 1;display: flex;flex-direction: column;">
      <span class="title">{{ downElementBlock.title }}</span>
      <slot v-for="elementName in downElementBlock.elementNames" :name="elementName" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabCustomsInfoUICustomLayout',
  props: {
    elementBlocks: { type: Array, required: true }
  },
  computed: {
    upElementBlock() {
      return this.elementBlocks.find(p => p.position === 1 && !p.hide)
    },
    downElementBlock() {
      return this.elementBlocks.find(p => p.position === 2 && !p.hide)
    }
  }
}
</script>
